<template>
  <div>
    <v-card flat>
      <v-list-item-title class="title-font py-2">
        SHIPPING ADDRESSES
        <v-btn class="btn-primary ml-4" small @click="addAddress"
          ><v-icon class="mr-2">mdi-plus</v-icon>Add</v-btn
        >
        <v-card-text v-if="loading" class="text-center">
          <v-progress-circular indeterminate color="primary" />
        </v-card-text>
      </v-list-item-title>
      <v-card flat class="mx-4 rounded-10">
        <v-simple-table>
          <thead>
            <tr>
              <th style="width: 1%; white-space: nowrap">Name</th>
              <th style="width: 1%; white-space: nowrap"></th>
              <th>Address</th>
              <th class="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(address, index) in tenantShippingAddresses"
              :key="index"
            >
              <td style="white-space: nowrap">
                {{ address.name }}
              </td>
              <td style="white-space: nowrap">
                <v-chip
                  v-if="
                    address.uid ===
                    tenantInformation.primary_shipping_address_uid
                  "
                  color="primary"
                  small
                  class="px-2 ml-1 mb-1"
                >
                  Primary
                </v-chip>
              </td>
              <td>
                {{ shippingAddressText(address, false) }}
              </td>
              <td class="text-right">
                <v-icon
                  small
                  class="mr-2"
                  @click="editShippingAddress(address)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteShippingAddress(address)"
                  :disabled="
                    address.uid ===
                    tenantInformation.primary_shipping_address_uid
                  "
                >
                  mdi-delete
                </v-icon>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="600px"
      content-class="rounded-20"
      persistent
    >
      <v-card class="rounded-20 pa-4">
        <ShippingAddressModal
          v-model="selectedAddress"
          @confirm="confirm"
          @cancel="reset"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      max-width="550px"
      content-class="rounded-20"
    >
      <v-card>
        <v-card-title class="text-h5 off">
          Are you sure you want to delete this address?
        </v-card-title>
        <v-card-actions class="off">
          <v-spacer />
          <v-btn text color="error" class="rounded-10 mx-2" @click="reset">
            Cancel
          </v-btn>
          <v-btn class="btn-primary mx-2" @click="deleteAddressConfirm">
            OK
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { shippingAddressText } from "@/utils"
import { mapGetters, mapActions } from "vuex"
import client from "@/lib/ApiClient"
import ShippingAddressModal from "./TenantShippingAddresses/ShippingAddressModal.vue"

export default {
  name: "TenantShippingAddresses",

  props: ["tenantInformation"],

  components: {
    ShippingAddressModal
  },

  data() {
    return {
      loading: false,
      dialog: false,
      deleteDialog: false,
      selectedAddress: null,
      newAddress: false,
      blankAddressForm: {
        name: null,
        primary: false,
        address_1: null,
        address_2: null,
        suburb: null,
        state: null,
        postal_code: null,
        country: null
      }
    }
  },

  computed: {
    ...mapGetters(["tenantShippingAddresses"])
  },

  methods: {
    ...mapActions(["triggerReload"]),

    shippingAddressText,

    addAddress() {
      this.dialog = true
      this.newAddress = true
      this.selectedAddress = this.blankAddressForm
    },

    editShippingAddress(shippingAddress) {
      this.selectedAddress = { ...shippingAddress }
      if (
        this.selectedAddress.uid ===
        this.tenantInformation.primary_shipping_address_uid
      )
        this.selectedAddress.primary = true
      this.dialog = true
    },

    deleteShippingAddress(shippingAddress) {
      this.selectedAddress = shippingAddress
      this.deleteDialog = true
    },

    async confirm() {
      this.loading = true
      if (this.newAddress) {
        await client.gateway.tenants.addTenantShippingAddress(
          this.selectedAddress
        )
      } else {
        await client.gateway.tenants.updateTenantShippingAddress(
          this.selectedAddress.uid,
          this.selectedAddress
        )
      }
      this.triggerReload("shippingAddresses")
      this.reset()
    },

    deleteAddressConfirm() {
      client.gateway.tenants.deleteShippingAddress(this.selectedAddress.uid)
      this.triggerReload("shippingAddresses")
      this.deleteDialog = false
      this.reset()
    },

    reset() {
      this.dialog = false
      this.deleteDialog = false
      this.selectedAddress = this.blankAddressForm
      this.newAddress = false
      this.$emit("reloadTenant")
      this.loading = false
    }
  }
}
</script>
